import { Component, OnInit } from '@angular/core';
import { UserService } from '../../lib/user.service';
import { OrganizationService } from '../../lib/organization.service';
import { ApiService } from '../../lib/api.service';
import { LogService } from '../../lib/log.service';
import { User } from '../../models/user';
import { Organization, OrganizationCourse } from '../../models/organization';
import { Router } from '@angular/router';
import { UrlService } from '../../lib/url.service';
import { SvgIconComponent } from 'app/components/svg-icon/svg-icon.component';
import { Location } from '@angular/common';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ModalService } from 'app/lib/modal.service';
import { SeriesService } from 'app/lib/series.service';

@Component({
    selector: 'app-theory',
    templateUrl: './theory.component.html',
    styleUrls: ['./theory.component.scss'],
    standalone: false
})
export class TheoryComponent implements OnInit {
    user: User;
    organization: any;
    access: any;
    loaded: boolean;
    enabledCourses: OrganizationCourse[];
    defaultCourses: OrganizationCourse[];
    ssoLink: string;
    count: any;

    courseList: any = {};
    categoryList = [];
    categorySelected: number = 0;
    filteredCourseList: any = [];
    isOpen = false;
    constructor(
        private userService: UserService,
        private api: ApiService,
        private logService: LogService,
        private organizationService: OrganizationService,
        private router: Router,
        private urlService: UrlService,
        private location: Location,
        private translate: TranslateService,
        private modalService: ModalService,
        private seriesService: SeriesService
    ) {
        this.loaded = false;
        this.access = {
            anxiety: true,
            depression: true,
            publicspeaking: true,
            disaster: true,
            purpose: true,
            mindfulness: true,
            sleep: false,
            work: false,
            depression_new: true,
        };
        this.urlService.setCurrentUrl(null);
        this.categorySelected = 0;
    }

    ngOnInit() {
        this.defaultCourses = [];
        this.ssoLink = '';
        this.user = this.userService.getUser();

        this.loadCourses();
        this.getCategories();
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.defaultCourses = [];
            this.enabledCourses = [];
            this.courseList = [];
            this.loadCourses();
        });
    }

    loadCourses() {
        this.seriesService.videoSeries.subscribe((data: any) => {
            if (!data || data.status == 'error') return;
            if (data.status == 'success') {
                this.setCoursePermissions(data.seriesList);
                data.seriesList;
            }
        });
        this.seriesService.getCourses();
        // if (this.user.primaryOrganization && this.user.primaryOrganization.id) {
        //     this.api
        //         .get('organizations/' + this.user.primaryOrganization.id, {
        //             fetchcourseimg: true,
        //         })
        //         .subscribe(
        //             (result: any) => {
        //                 this.organization = new Organization(
        //                     result.data,
        //                     'full'
        //                 );
        //                 if (
        //                     this.organization.courses !== undefined &&
        //                     this.organization.courses.length > 0
        //                 ) {
        //                     this.enabledCourses = this.organization.courses;
        //                     this.unlock();
        //                 } else {
        //                     this.loadDefaultCourses();
        //                 }
        //                 if (
        //                     this.organization.integrations &&
        //                     this.organization.integrations.togetherAllSsoLink
        //                 ) {
        //                     this.ssoLink =
        //                         this.organization.integrations.togetherAllSsoLink;
        //                     localStorage.setItem('ssoLink', this.ssoLink);
        //                 } else {
        //                     localStorage.removeItem('ssoLink');
        //                 }
        //             },
        //             (error: any) => {
        //                 this.logService.error(
        //                     'Error getting organizations. ' + error.message
        //                 );
        //             }
        //         );
        // } else {
        //     this.loadDefaultCourses();
        // }
    }

    // loadDefaultCourses() {
    //     this.api.get('series/serieslisting/defaults').subscribe(
    //         (result: any) => {
    //             if (result.data) {
    //                 result.data.forEach(course => {
    //                     this.defaultCourses.push(
    //                         new OrganizationCourse({
    //                             id: course.ID,
    //                             courseId: course.ID,
    //                             key: course.CourseKey,
    //                             name: course.Name,
    //                             description: course.Description,
    //                             enabled: course.DefaultCourse,
    //                             videoCount: course.videoCount,
    //                             length: course.Length,
    //                             courseImage: course.CourseImage,
    //                             completed: course.completed,
    //                         })
    //                     );
    //                 });
    //                 this.unlock();
    //             }
    //         },
    //         (error: any) => {
    //             this.logService.error('Error getting Series. ' + error.message);
    //         }
    //     );
    // }

    // unlock() {
    //     if (this.enabledCourses && this.enabledCourses.length > 0) {
    //         this.setCoursePermissions(this.enabledCourses);
    //     } else {
    //         this.setCoursePermissions(this.defaultCourses);
    //         this.logService.debug('default Series');
    //         this.logService.debug(this.defaultCourses);
    //     }
    // }
    setCoursePermissions(courses) {
        this.courseList = this.seriesService.setVideoSeriesPermissions(courses);
        if (!Object.keys(this.courseList).length) {
            this.filteredCourseList = [];
            return;
        } else {
            this.onCategoryChange();
        }

        this.loaded = true;
        if (!Object.keys(this.courseList).length) {
            this.filteredCourseList = [];
        } else {
            this.onCategoryChange();
        }
        this.count = Object.keys(this.courseList).length;
        if (this.count == 0) {
            this.modalService.showAlert(
                'Alert',
                'Your organization has not enabled any Series'
            );
            this.router.navigate(['/app']);
        }
    }

    onAdditionalInfo() {}

    goToCourse(course) {
        if (!this.user.isFullAccess) {
            this.showBlocked();
        } else {
            this.router.navigateByUrl('app/series-details/' + course.key);
        }
    }
    async showBlocked() {
        // const modal = await this.modalCtrl.create({ component: BlockedModal });
        // await modal.present();
    }
    goBack() {
        this.location.back();
    }
    onCategoryChange() {
        if (this.categorySelected !== 0) {
            this.filteredCourseList = Object.values(this.courseList).filter(
                (value: any) => value.category == this.categorySelected
            );
        } else {
            this.filteredCourseList = Object.values(this.courseList);
        }
    }
    getCategories() {
        this.seriesService.categories.subscribe(data => {
            let filtered = (data || []).filter(cat => cat.hasVideos > 0);
            if (filtered.length > 1) {
                this.categoryList = [{ ID: 0, Title: 'All', hasVideos: true }, ...filtered];
                this.categorySelected = 0;
            } else {
                this.categoryList = filtered;
                this.categorySelected = filtered.length > 0 ? filtered[0].ID : 0;
            }
        });
        this.seriesService.getCategories();
    }
}
